
export const TOKEN_STORAGE = 'storage_api_key'
export const MAX_ZOOM_VALUE = 24

export interface SideBarItem {
  id: number
  kind: string
  listed: boolean
}

export interface LayerGroup extends SideBarItem {
  kind: 'group'
  name: string
  layers: Layer[]
}

export interface Layer extends SideBarItem {
  kind: 'layer'
  name: string
  desc: string
  type:  "background" | "wms" | "esri" | "special"
  url: string
  options: any
  selected: boolean
  zIndex: number
  data?: any
}

export type User = {
  id: number
  email: string
  admin: boolean
  active: number[]
  order: number[]
  zoom?: number
  layers: number[]
  dangers: boolean
}

export type Danger = {
  id: number
  name: string
  raster: boolean
}

export type LoginRequest = {
  email: string
  password: string
}

export type Profile = {
  email: string
  admin: boolean
  zoom?: number
  active: number[]
  order: number[]
  dangers: boolean
}

export type LoginGroup = {
  id: number
  name: string
  layers: number[]
}

export type LoginResponse = {
  email: string
  admin: boolean
  zoom: number
  active: number[]
  order: number[]
  listed: number[]
  token: string
  layers: Layer[]
  groups: LoginGroup[]
  background: number
  opacity: {[s: number]: number}
  dangers: boolean
}

export type PasswordChange = {
  current: string
  password: string
}

export interface AdminLayerGroup extends SideBarItem {
  kind: 'group'
  name: string
  layers: number[]
}

export type Radios = {
  id: number
  lat: number
  lon: number
  r1: number
  c1: string
  r2: number
  c2: string
  r3: number
  c3: string
}